import { createContext } from 'react';

const seekerContext = createContext();

export default seekerContext;
